import {SearchRule} from 'constants/SequenceOpConstants';
import FileStates from 'FileStates';
import * as TaskRunner from 'util/TaskRunner';

import {BulkEditModsResult} from './BulkEditModsConstants';

interface BulkPreviewFindAndReplaceResponse {
  results: Array<BulkEditModsResult>;
  conflicts: Array<number>;
}

export function bulkPreviewFindAndReplace(
  sequenceVersionIds: Array<number>,
  rules: Array<SearchRule>
): Promise<BulkPreviewFindAndReplaceResponse> {
  return TaskRunner.postJSONPromise({
    url: `/1/api/bulk-preview-find-and-replace`,
    data: {sequenceVersionIds, rules},
  });
}

export type BulkApplyFindAndReplaceParams = {
  sequenceVersionIds: Array<number>;
  rules: Array<SearchRule>;
  isBulk: boolean;
} & ({shouldClone: false; folderId: null} | {shouldClone: true; folderId: string});

export async function bulkApplyFindAndReplace({
  sequenceVersionIds,
  rules,
  isBulk,
  shouldClone,
  folderId,
}: BulkApplyFindAndReplaceParams): Promise<BulkPreviewFindAndReplaceResponse> {
  const response: BulkPreviewFindAndReplaceResponse = await TaskRunner.postJSONPromise({
    url: `/1/api/bulk-apply-find-and-replace`,
    data: {sequenceVersionIds, rules, shouldClone, folderId},
  });

  // Open the newly created sequence if the rules were applied from a single-edit pathway
  const updatedSequenceIds = response.results
    .map((result) => result.updatedId)
    .filter((id): id is string => id != null);
  if (shouldClone && !isBulk && updatedSequenceIds.length > 0) {
    FileStates.get().openFolderItem(updatedSequenceIds[0]);
  }
  return response;
}
